<template>
  <ion-page>
    <ion-content color="primary" class="recovery-wrapper">
      <div class="d-flex flex-column justify-space-evenly h-100 align-center">
        <div class="recovery-wrapper__logo ion-justify-content-center">
          <ion-img v-if="arriboLogo" :src="arriboLogo" alt="Arribo Logo"></ion-img>
        </div>

        <div class="content">
          <ion-card class="recovery-wrapper__form ion-padding border-default no-shadow bg-white">
            <h3 class="h3 text-color-body text-align-center">{{ t('recovery.title') }}</h3>
            <div class="mt-lg">
              <Form
                form-name="recovery"
                id="recoveryForm"
                :validation-schema="schemaRecoveryEmail"
                @submit="handleRecoverySubmit"
              >
                <ion-row gap="0">
                  <ion-col size="12">
                    <CustomInput
                      form-name="login"
                      type="text"
                      :value="email"
                      v-model="email"
                      input-type="email"
                      :label="t('login.labels.email')"
                      name="email"
                      class-name="custom-field"
                      placeholder="name@domain.com"
                      :icon="mailOutline"
                    />
                  </ion-col>
                </ion-row>
                <ion-row class="mt-lg">
                  <ion-col size="12">
                    <ion-button
                      :disabled="loading"
                      fill="solid"
                      class="text-sm"
                      color="primary"
                      expand="block"
                      size="default"
                      type="submit"
                    >
                      {{ t('actions.recovery') }}
                    </ion-button>
                  </ion-col>
                  <ion-col size="12">
                    <ion-button
                      fill="clear"
                      class="text-lg text-underline mt-lg mb-lg"
                      color="primary"
                      expand="block"
                      size="small"
                      @click="goTo('login')"
                    >
                      {{ t('welcome.haveAnAccount') }}
                    </ion-button>
                  </ion-col>
                </ion-row>
              </Form>
            </div>
            <ion-progress-bar v-if="loading" type="indeterminate"></ion-progress-bar>
          </ion-card>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import {
    IonPage,
    IonContent,
    IonRow,
    IonCol,
    IonImg,
    IonButton,
    IonCard,
    IonProgressBar,
  } from '@ionic/vue';
  import arriboLogo from '@/assets/images/arribo-logo.svg';
  import { useAuth } from '@/composables/useAuth';
  import { useI18n } from 'vue-i18n';
  import { ref } from 'vue';
  import { Form } from 'vee-validate';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { mailOutline } from 'ionicons/icons';
  import { useProfile } from '@/composables/useProfile';
  import { useSchemas } from '@/composables/useSchemas';

  const { schemaRecoveryEmail } = useSchemas();
  const { goTo } = useAuth();
  const { handleRecoveryPassword, recoveryPasswordSuccess, loading } = useProfile();
  const { t } = useI18n();

  const showErr = ref(false);
  const email = ref('');

  const handleRecoverySubmit = () => {
    goRecovery();
  };

  const goRecovery = () => {
    loading.value = true;
    showErr.value = false;
    try {
      handleRecoveryPassword(email.value).then(() => {
        loading.value = false;
        if (recoveryPasswordSuccess.value) {
          goTo('login');
        }
      });
    } catch (error: unknown) {
      loading.value = false;
      const errorMsg = error?.toString() ?? 'Unknown error!';
      if (errorMsg === 'Error: Invalid email!') {
        showErr.value = true;
      }
    }
  };
</script>
<style scoped lang="scss">
  .recovery-wrapper {
    position: relative;

    &__logo {
      position: relative;
      margin-top: 70px;
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 190px;
      }
    }
  }
</style>
